import { render } from "./sidebar_cart.vue?vue&type=template&id=50fdc353"
import script from "./sidebar_cart.vue?vue&type=script&lang=js"
export * from "./sidebar_cart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__